import useSWR from 'swr';

import { useCurrentProjectId } from '@adsk/alloy-provider';

import { FORMS_SWR_CONFIG } from '../helpers/constants';
import { formsClient, formsRoutes } from '../helpers/formsClient';
import getFoldersTransformers, {
  FETCH_FOLDERS_LIMIT,
} from '../helpers/transformers/getFolders';

export default () => {
  const projectId = useCurrentProjectId();

  const { data, error } = useSWR(
    formsRoutes.folders(projectId),
    async () => {
      const fetchFoldersRequests = [];

      const initialFoldersPage = await formsClient.getFolders(projectId, {
        offset: 0,
        limit: FETCH_FOLDERS_LIMIT,
      });

      if (!initialFoldersPage.pagination.nextUrl) {
        const { documents } = getFoldersTransformers.translateResponse([
          initialFoldersPage,
        ]);
        return documents;
      }

      const numRequests =
        Math.ceil(
          initialFoldersPage.pagination.totalResults / FETCH_FOLDERS_LIMIT,
        ) - 1;

      for (let i = 1; i <= numRequests; i++) {
        fetchFoldersRequests.push(
          formsClient.getFolders(projectId, {
            offset: FETCH_FOLDERS_LIMIT * i,
            limit: FETCH_FOLDERS_LIMIT,
          }),
        );
      }

      const foldersPages = await Promise.all(fetchFoldersRequests);

      const { documents } = getFoldersTransformers.translateResponse([
        initialFoldersPage,
        ...foldersPages,
      ]);

      return documents;
    },
    FORMS_SWR_CONFIG,
  );

  return {
    data,
    isError: error,
    isLoading: !error && !data,
  };
};
